import React, { useState, useEffect } from "react";
import { Button, Popover } from "@mui/material";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import CoreSelectObjArr from "../../../../app/core/components/CoreSelect/CoreSelectObjArr";
import CoreFilterButtonIcon from "../../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";

const PracticeDocumentFilter = ({ filter, setFilter, setPage }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [subCategories, setSubCategoriesList] = useState([]);
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const [formData, setFormData] = useState({
    mainCategoryId: "",
    categoryId: "",
  });

  useEffect(() => {
    setFormData(filter);
  }, [filter]);

  const categories = useSelector((state) => state.categories.macroCategories);
  const macroCategories = categories?.map((cat) => ({
    label: cat?.name,
    value: cat?.id,
  }));

  //POPOVER HANDLERS
  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  // HANLDE CHANGE

  const handleMacroChange = (event) => {
    const selectedValue = event.target.value;
    const subCategories = categories.filter((mC) => mC.id === selectedValue);

    setSubCategoriesList(
      subCategories[0].expenseCategories.map((sub) => ({
        label: sub?.name,
        value: sub?.id,
      }))
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      [event.target.name]: selectedValue,
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFilter = () => {
    setFilter(formData);
    setPage({
      currentPage: 1,
      startRow: 0,
      endRow: TABLE_ROWS_NUMBER,
    });
    handleClosePopover();
  };

  const handleReset = () => {
    setFormData({
      mainCategoryId: "",
      categoryId: "",
    });
    setFilter({
      mainCategoryId: "",
      categoryId: "",
    });
    handleClosePopover();
  };

  return (
    <div>
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: "8px", marginTop: "5px" } }}
      >
        <div className="w-[30rem] p-4">
          <form>
            <div className="flex flex-col space-y-4">
              <h2 className="mb-2 text-lg">{t("Category")}</h2>
              <CoreSelectObjArr
                name="mainCategoryId"
                label={t("MacroCategory")}
                value={formData.mainCategoryId}
                items={macroCategories || []}
                onChange={handleMacroChange}
              />
              <CoreSelectObjArr
                name="categoryId"
                label={t("SubCategory")}
                value={formData.categoryId}
                items={subCategories || []}
                onChange={handleInputChange}
              />
            </div>

            <div className="flex space-x-4 mt-4">
              <Button
                className="bg-red-700 text-white w-full"
                onClick={handleReset}
                sx={{ marginTop: "16px" }}
              >
                Reset
              </Button>
              <Button
                className="text-white w-full"
                style={{ backgroundColor: `${colorPrimary}` }}
                onClick={handleFilter}
                sx={{ marginTop: "16px" }}
              >
                {t("Apply")}
              </Button>
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default PracticeDocumentFilter;
